module.exports = __webpack_public_path__ + "img/full4-min.6dabd00c.png";